import React from "react";
import {  useState } from "react";
import { useTranslation } from "react-i18next";
import Action from "./Action";
import ShowItems from "./ShowItems";
import styles from "../NotesPage.module.scss";

import { deleteNotes, getNotesData, patchNotes,getNotes } from "service/NotesService";
import Notification from "utils/Notifications";
const Items = ({ id, body, createdAt, archived, action }) => {
  const { t } = useTranslation('common');
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const onDeleteNote = async (item) => {


    await deleteNotes(id);
    setNotify({
      isOpen: true,
      message: t('notes.note_deleted'),
      type: "success",
    });
    action((notes) => notes.filter((note) => note.id !== item));


  };
  const [data, setData] = useState([]);
  const onArchiveNote = async (item) => {
    if (!archived){
      await patchNotes(id);
      setNotify({
      isOpen: true,
      message: t('notes.note_archived'),
      type: "success",
    });

    action((notes) =>
    notes.map((note)  => {
      if (note.id === item) {
        return { ...note, archived: !note.archived };
      }
      return note;
    }));
  }
     else {
      let response = await patchNotes(id);
      setNotify({
      isOpen: true,
      message: t('notes.note_unarchived'),
      type: "success",
    });
    action((notes) =>
    notes.map((note) => {
      if (note.id === item) {
        return { ...note, archived: !note.archived };
      }
      return note;
    }));
     }
  };

  return (
    <div className={styles["note-item"]}>
      <ShowItems
        id = {id}
        body={body}
        createdAt={createdAt}
        archived={archived}
        action={action}
      />
      
      <Action
        onDeleteNote={onDeleteNote}
        onArchiveNote={onArchiveNote}
        id={id}
        archived={archived}
      />
       <Notification notify={notify} setNotify={setNotify} />
    </div>
    
  );
};

export default Items;
